import React from 'react';

import Button from '@mui/material/Button';

type Props = {
  label: string;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'error' | 'success' | 'warning' | 'info' | 'inherit';
  startIcon?: React.ReactNode;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  dashed?: boolean;
};

/**
 * ガイド画面で表示用のモックボタン（操作不能）
 */
const GuideMockButton: React.FC<Props> = ({
  label,
  variant = 'contained',
  color = 'primary',
  startIcon,
  size = 'small',
  fullWidth = false,
  dashed = false,
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      startIcon={startIcon}
      fullWidth={fullWidth}
      sx={{
        pointerEvents: 'none',
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 600,
        boxShadow: 'none',
        ...(dashed && {
          borderStyle: 'dashed',
        }),
      }}
    >
      {label}
    </Button>
  );
};

export default GuideMockButton;
